/**
 * @typedef {Object} HrefObject
 * @property {string} pathname
 * @property {Object} state
 * @property {string} state.previousLocation
 * @property {string} search
 */

/**
 * @param {string} jobId
 * @param {string} currentLocation
 * @returns {HrefObject}
 */
export const buildJobDetailsHref = (jobId, currentLocation) => {
  return {
    pathname: `jobs/${jobId}`,
    state: { previousLocation: currentLocation },
    search: '?show_feedback_form',
  }
}
